import IResponseModel from "@/api/ResponseModel";
import SystemSettingApi from "@/api/SystemSettingApi";
import SystemSetting from "@/models/SystemSetting";

export default class SystemSettingUseCase {
  private readonly _systemSettingApi: SystemSettingApi;

  constructor(systemsettingApi: SystemSettingApi = new SystemSettingApi()) {
    this._systemSettingApi = systemsettingApi;
  }

  async getAll(): Promise<IResponseModel<SystemSetting>> {
    try {
      const result = await this._systemSettingApi.getSystemSetting();

      return result;
    } catch (error) {
      throw error;
    }
  }

  async getPublicKey(): Promise<IResponseModel<string>> {
    try {
      const result = await this._systemSettingApi.getPublicKey();

      return result;
    } catch (error) {
      throw error;
    }
  }
}
